import VStack from "../primitives/VStack";

export default function PlaceholderScreen() {
  return (
    <VStack>

    </VStack>
  )
}